export enum AuthRole {
    anonymous = "Anonymous",
    administrator = "Administrator",
    authenticated = "Authenticated"
}